module.exports = __webpack_public_path__ + "static/image-placeholder-10697310d866c75f85f5469ea61ebc18.png";